import { render, staticRenderFns } from "./HomeSuperkid.vue?vue&type=template&id=e1715b2e&scoped=true&"
import script from "./HomeSuperkid.vue?vue&type=script&lang=js&"
export * from "./HomeSuperkid.vue?vue&type=script&lang=js&"
import style0 from "./HomeSuperkid.vue?vue&type=style&index=0&id=e1715b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1715b2e",
  null
  
)

export default component.exports